import React from "react";
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  LinearProgress
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";

import I18nText from "../../../../../elements/I18nText";
import FormattedDate from "../../../../../elements/FormattedDate";
import {
  PrimaryButton,
  SecondaryButton,
  ButtonsWrapper
} from "../../../../../elements/Button";
import {
  ListActionsWrapper,
  EditAction,
  DeleteAction
} from "../../../../../elements/ListAction";
import NoData from "./NoData";

const CommentList = ({
  comments,
  commentLimit,
  isRefreshing,
  onAdd,
  onEdit,
  onDelete,
  onClose
}) => {
  const limitReached = comments.length >= commentLimit;

  return (
    <>
      {isRefreshing && <LinearProgress color="secondary" />}

      <Grid container>
        <Grid item xs={12}>
          <Box
            my={2}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {limitReached && (
              <Box fontSize={13} color="text.secondary" marginRight={2}>
                <I18nText values={{ limit: commentLimit }}>
                  devices.settings.metadata.comment.limitReached
                </I18nText>
              </Box>
            )}
            <PrimaryButton
              onClick={onAdd}
              disabled={limitReached}
              icon={<AddIcon />}
            >
              <I18nText>devices.settings.metadata.comment.actions.new</I18nText>
            </PrimaryButton>
          </Box>
        </Grid>
      </Grid>

      {comments.length === 0 ? (
        <NoData />
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <I18nText>
                    devices.settings.metadata.comment.table.header.date
                  </I18nText>
                </TableCell>
                <TableCell>
                  <I18nText>
                    devices.settings.metadata.comment.table.header.addedBy
                  </I18nText>
                </TableCell>
                <TableCell>
                  <I18nText>
                    devices.settings.metadata.comment.table.header.comment
                  </I18nText>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {comments.map(comment => (
                <TableRow key={comment.id}>
                  <TableCell>
                    <FormattedDate>{comment.date}</FormattedDate>
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    {comment.author || "system"}
                  </TableCell>
                  <TableCell
                    style={{
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      maxWidth: 320
                    }}
                  >
                    {comment.comment}
                  </TableCell>
                  <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
                    <ListActionsWrapper>
                      <EditAction onClick={() => onEdit(comment)} />
                      <DeleteAction onClick={() => onDelete(comment)} />
                    </ListActionsWrapper>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box marginTop={2}>
            <ButtonsWrapper
              rightButton={
                <SecondaryButton onClick={onClose} icon={<CloseIcon />}>
                  <I18nText>actions.close</I18nText>
                </SecondaryButton>
              }
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default CommentList;
